import React, {useContext} from 'react';
import {Col, Modal, Row} from "react-bootstrap";
import {SecurityContext} from "../../context/security";
import {WEB_ANNOUNCEMENTS_DELETE_URL} from "../../service/UrlConstant";


export default function DeleteAnnouncementModal(props){
    const {makeDeleteRequestWithParams} = useContext(SecurityContext);

    const handleDeleteClose = ()=>{
        props.setShow(false)
        props.setShowDelete(false)
    }
    const handleAnnouncementDelete  = () => {
        const onSuccess = (response) => {
            if(response.data === 'Announcement deleted successfully.'){
                const updatedAnnouncements = props.announcements.filter((announcement)=>
                    props.announcementToBeDeleted.announcementId !== announcement.announcementId)
                props.setAnnouncements(updatedAnnouncements);
            }
            props.setShow(false);
            props.setShowDelete(false);
        }
        const onError = (err) => {
            console.error(err);
        }

        makeDeleteRequestWithParams(props.announcementToBeDeleted, WEB_ANNOUNCEMENTS_DELETE_URL, onSuccess, onError);
    };
    return <div> <Modal
            show={props.show  && props.showDelete}
            onHide={handleDeleteClose}
            className='p-0'
            backdrop='static'
            centered
    >
            <Modal.Header
                closeButton
                style={{textAlign: 'right', border:'none', alignSelf:'flex-end'}}>
            </Modal.Header>
            <Col md={12}  className='pl-8'>
                <h2 style={{textAlign:'left'}} className='mb-4'>Delete Notification</h2>
                <h4 style={{textAlign:'left'}}>Are you sure you want to delete this announcement?</h4><br/>
            </Col>
            <Row className='p-4 pb-5 pr-8 pl-8 justify-content-center'>
                <Col className="col-5">
                    <button className='btn btn-block td-btn-secondary-clear' href="#" onClick={handleDeleteClose}>Cancel
                    </button>
                </Col>
                <Col className="col-5">
                    <button  href="#"
                             className={"btn btn-block td-btn-red"}
                             onClick={handleAnnouncementDelete}>Delete
                    </button>
                </Col>
            </Row>
        </Modal>
    </div>
}